export default function navData() {
	return {
		logo: {
			name: 'The B.R.U.G. Method',
			href: '/',
		},
		left: [
			{
				name: 'Home',
				href: '/home',
			},
			{
				name: 'Courses',
				href: '/courses',
			},
		],
		right: [
			{
				name: 'Video Content',
				href: '/videocontent',
			},
			{
				name: 'Contact Me',
				href: '/contact',
			},
			{
				name: 'Support',
				href: '/support',
			},
		],
		auth: [
			{
				name: 'Sign Up',
				href: '/signup',
			},
			{
				name: 'Sign in',
				href: '/signin',
			},
		],
	};
}
